import React from 'react'
import { func, oneOf } from 'prop-types'
import { styled } from '@creditas-ui/react'
import { CreditasIconPrincipal } from '@creditas/logos-react'
import { ArrowLeft, Close } from '~components/Icons'

const propTypes = {
  onClick: func.isRequired,
  type: oneOf(['close', 'back', 'logo']).isRequired,
}

const ButtonHeaderStyle = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  outline: none;
  width: 50px;
  height: 50px;
  cursor: pointer;
  padding: 0;
`

const IconCloseStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0;
  width: 50px;
  height: 50px;
`

const icons = {
  close: (
    <IconCloseStyle>
      <Close data-testid="close" />{' '}
    </IconCloseStyle>
  ),
  back: <ArrowLeft data-testid="back" />,
  logo: <CreditasIconPrincipal width={33} height={24} data-testid="logo" />,
}

const ButtonHeader = ({ onClick, type, ...props }) => {
  return (
    <ButtonHeaderStyle onClick={onClick} type="button" {...props}>
      {icons[type]}
    </ButtonHeaderStyle>
  )
}

ButtonHeader.propTypes = propTypes

export { ButtonHeader }
